import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Papa from "papaparse";
import { FaDownload } from "react-icons/fa";

const AllCandidates = () => {
  const [allCandidatesList, setAllCandidatesList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  const downloadCSV = () => {
    if (!filteredList.length) {
      toast.info("No data to export");
      return;
    }

    const selectedFields = filteredList.map((employee) => ({
      EmployeeId: employee.employeeId ? `CMPL${employee.employeeId}` : "NAN",
      name: employee.full_Name ?? "NAN",
      Father_Name: employee.care_of ?? "NAN",
      Contact: employee.contact ?? "NAN",
      Address: `${employee.house ?? "NAN"}, ${employee.street ?? "NAN"}, ${
        employee.landmark ?? "NAN"
      }, ${employee.loc ?? "NAN"}, ${employee.subdist ?? "NAN"}, ${
        employee.dist ?? "NAN"
      }, ${employee.state ?? "NAN"} - ${employee.zip ?? "NAN"}`,
      pan_name: employee.pan_name ?? "NAN",
      pan_number: employee.pan_number ?? "NAN",
      aadharNumber: employee.aadhar_number ?? "NAN",
      account_name: employee.account_name ?? "NAN",
      account_number: `'${employee.account_number ?? "NAN"}`,
      Ifsc: employee.account_ifsc ?? "NAN",
    }));

    // Convert the employee data to CSV format
    const csv = Papa.unparse(selectedFields);

    // Create a downloadable link for the CSV file
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "employee_list.csv"; // Name of the CSV file
    a.click(); // Trigger the download
  };

  const fetchingCandidates = async () => {
    try {
      setLoading(true);
      await axios
        .get(
          `${process.env.REACT_APP_BACKEND_URL}/api/establishment/all-candidates`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          setAllCandidatesList(res.data.users);
          setFilteredList(res.data.users);
          setLoading(false);
        });
    } catch (e) {
      toast.error("error in fetching data");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchingCandidates();
  }, []);

  if (loading) {
    return <div className="p-4">Loading...</div>;
  }

  const changeHandle = (e) => {
    const query = (e.target.value || "").toLowerCase().trim();
    const normalizedQuery = query.startsWith("cmpl") ? query.slice(4) : query;

    const filteredData =
      allCandidatesList && allCandidatesList.length
        ? allCandidatesList.filter(
            (hired) =>
              (hired.full_Name || "").toLowerCase().includes(query) ||
              (hired.employeeId || "").toString().toLowerCase().includes(normalizedQuery)
          )
        : [];
    setFilteredList(filteredData);
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">
        <h4 className="mb-0">All Candidates</h4>
        <div className="d-flex gap-2">
          <input
            type="text"
            className="form-control"
            placeholder="Search by name or ID"
            onChange={changeHandle}
            style={{ minWidth: "220px" }}
          />
          <button className="btn btn-outline-secondary" onClick={downloadCSV}>
            <FaDownload className="me-1" /> Export
          </button>
        </div>
      </div>
      {!filteredList.length ? (
        <p className="text-muted">No candidates found.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped align-middle">
            <thead className="table-light">
              <tr>
                <th>Employee ID</th>
                <th>Name</th>
                <th>Father Name</th>
                <th>Contact</th>
                <th>Address</th>
                <th>PAN Name</th>
                <th>PAN Number</th>
                <th>Aadhar Number</th>
                <th>Account Name</th>
                <th>Account Number</th>
                <th>IFSC</th>
              </tr>
            </thead>
            <tbody>
              {filteredList.map((user) => {
                const fullAddress = `${user.house ?? "NAN"}, ${user.street ?? "NAN"}, ${
                  user.landmark ?? "NAN"
                }, ${user.loc ?? "NAN"}, ${user.subdist ?? "NAN"}, ${
                  user.dist ?? "NAN"
                }, ${user.state ?? "NAN"} - ${user.zip ?? "NAN"}`;

                return (
                  <tr key={user._id}>
                    <td>{user.employeeId ? `CMPL${user.employeeId}` : "NAN"}</td>
                    <td className="fw-semibold">{user.full_Name ?? "NAN"}</td>
                    <td>{user.care_of ?? "NAN"}</td>
                    <td>{user.contact ?? "NAN"}</td>
                    <td>{fullAddress}</td>
                    <td>{user.pan_name ?? "NAN"}</td>
                    <td>{user.pan_number ?? "NAN"}</td>
                    <td>{user.aadhar_number ?? "NAN"}</td>
                    <td>{user.account_name ?? "NAN"}</td>
                    <td>{user.account_number ?? "NAN"}</td>
                    <td>{user.account_ifsc ?? "NAN"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AllCandidates;
